import { useSelector, useDispatch } from 'react-redux';

import { Tooltip, PMIIcon } from '@frontend/legacy-components';

import { pmiViewTool } from 'modules/common/viewer/cadViewer/data/actions';
import {
  getIsPMIViewActive,
  getHasPMIAnnotations,
} from 'modules/common/viewer/cadViewer/data/reducer';
import {
  ViewerButton,
  ViewerButtonTooltip,
} from 'modules/common/viewer/components';

const PMIViewTool = ({ isEnabled }) => {
  const dispatch = useDispatch();
  const isPMIViewActive = useSelector(getIsPMIViewActive);
  const hasPMIAnnotations = useSelector(getHasPMIAnnotations);
  return isEnabled ? (
    <Tooltip
      placement="bottom"
      label={
        hasPMIAnnotations ? (
          isPMIViewActive ? (
            <ViewerButtonTooltip firstLine="Hide PMI (beta)" />
          ) : (
            <ViewerButtonTooltip firstLine="View PMI (beta)" />
          )
        ) : (
          <ViewerButtonTooltip firstLine="No PMI available" />
        )
      }
    >
      <ViewerButton
        isActive={isPMIViewActive}
        disabled={!hasPMIAnnotations}
        aria-label={
          hasPMIAnnotations
            ? isPMIViewActive
              ? 'Hide PMI (beta)'
              : 'View PMI (beta)'
            : 'No PMI available'
        }
        onClick={() => dispatch(pmiViewTool.toggle())}
      >
        <PMIIcon boxSize={3} />
      </ViewerButton>
    </Tooltip>
  ) : null;
};

export default PMIViewTool;
